import type { DockPhase } from '@/features/ai-changeset/utils/dock-history';

export type DockPlacement = 'top' | 'bottom';

export function dockPlacement(state: {
  phase: DockPhase;
  applying: boolean;
  discarding: boolean;
  notice: boolean;
  expanded: boolean;
}): DockPlacement {
  const openWork = state.phase !== 'idle' || state.applying || state.discarding || state.notice;
  return openWork || state.expanded ? 'bottom' : 'top';
}
